import React from 'react';

import NextLink from 'next/link';

import { Nav, Navbar } from '@olist/united';

import { Image } from '@common/components/Image';

import FacebookIcon from '../Icons/Facebook';
import InstagramIcon from '../Icons/Instagram';
import LinkedinIcon from '../Icons/Linkedin';
import * as S from './Footer.style';

export const Footer: React.FC = () => {
  return (
    <S.Footer>
      <S.Container>
        <Navbar>
          <Navbar.Brand>
            <NextLink href="/" passHref>
              <a href="replace">
                <Image src="/images/vnda-network.svg" alt="logo da vnda" height="24px" />
              </a>
            </NextLink>
            <Nav>
              <Nav.Link
                href="https://www.facebook.com/vndaecommerce"
                target="_blank"
                rel="noreferrer"
                aria-label=""
              >
                <FacebookIcon />
              </Nav.Link>
              <Nav.Link
                href="https://www.instagram.com/vndaecommerce/"
                target="_blank"
                rel="noreferrer"
                aria-label=""
              >
                <InstagramIcon />
              </Nav.Link>
              <Nav.Link
                href="https://www.linkedin.com/company/vnda-ecommerce/"
                target="_blank"
                rel="noreferrer"
                aria-label=""
              >
                <LinkedinIcon />
              </Nav.Link>
            </Nav>
          </Navbar.Brand>
        </Navbar>
        <Navbar>
          <Nav>
            <Nav.Link
              to="/program"
              onClick={() => {
                const program = document.getElementById('program');
                program
                  ? program.scrollIntoView({ behavior: 'smooth', block: 'center' })
                  : (window.location.href = '/#program');
              }}
            >
              network program
            </Nav.Link>
            <Nav.Link
              to="/partners"
              onClick={() => {
                const partners = document.getElementById('partners');
                partners
                  ? partners.scrollIntoView({ behavior: 'smooth', block: 'center' })
                  : (window.location.href = '/#partners');
              }}
            >
              parceiros
            </Nav.Link>
            <Nav.Link
              to="/benefits"
              onClick={() => {
                const benefits = document.getElementById('benefits');
                benefits
                  ? benefits.scrollIntoView({ behavior: 'smooth', block: 'center' })
                  : (window.location.href = '/#benefits');
              }}
            >
              benefícios
            </Nav.Link>
            <Nav.Link
              to="/strategy"
              onClick={() => {
                const strategy = document.getElementById('strategy');
                strategy
                  ? strategy.scrollIntoView({ behavior: 'smooth', block: 'center' })
                  : (window.location.href = '/#strategy');
              }}
            >
              estratégia
            </Nav.Link>
            <Nav.Link
              to="/contact"
              onClick={() => {
                const contact = document.getElementById('contact');
                contact
                  ? contact.scrollIntoView({ behavior: 'smooth', block: 'center' })
                  : (window.location.href = '/#contact');
              }}
            >
              contato
            </Nav.Link>
          </Nav>
        </Navbar>
      </S.Container>
    </S.Footer>
  );
};
